import { render, staticRenderFns } from "./addEditWorkflow.vue?vue&type=template&id=9130cc66&scoped=true"
import script from "./addEditWorkflow.vue?vue&type=script&lang=js"
export * from "./addEditWorkflow.vue?vue&type=script&lang=js"
import style0 from "./addEditWorkflow.vue?vue&type=style&index=0&id=9130cc66&prod&lang=scss&scoped=true"
import style1 from "./addEditWorkflow.vue?vue&type=style&index=1&id=9130cc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9130cc66",
  null
  
)

export default component.exports